import React from "react";
import { FiCpu, FiHardDrive, FiLock, FiServer, FiUsers } from "react-icons/fi";

const stats = [
  ["Enterprise IT Support", FiHardDrive],
  ["Cybersecurity Compliance", FiLock],
  ["Network Systems", FiServer],
  ["Cloud Platforms", FiCpu],
  ["User Support", FiUsers]
];

function OperatorProfile() {
  return (
    <section className="ops-section" id="about">
      <div className="section-heading">
        <p>Identity Module</p>
        <h2>Operator Profile</h2>
      </div>
      <div className="profile-panel glass-panel">
        <div className="profile-card">
          <div className="profile-avatar" aria-hidden="true">EA</div>
          <div>
            <h3>Edwin "E" Arzu</h3>
            <p className="profile-clearance">Clearance: Public Portfolio // Focus: Enterprise IT + Cybersecurity Operations</p>
          </div>
        </div>
        <p>
          I am an IT and Cybersecurity professional with hands-on experience supporting enterprise-level systems, users, and compliance initiatives in an educational and vocational setting. I currently work as a Computer Systems Specialist, where I help keep daily operations running through troubleshooting, device configuration, inventory management, documentation, and escalation coordination.
        </p>
        <p>
          My background includes Windows Server, Cisco network equipment, Active Directory, Citrix, AWS, Azure, asset reviews for 200+ devices, policy authorship, device management procedures, and user education. I completed my Information Technology degree and am pursuing a Cybersecurity B.S. at Full Sail University, with coursework in IAM, network security, compliance, threat intelligence, and software security.
        </p>
        <div className="stat-grid">
          {stats.map(([label, Icon]) => (
            <div className="stat-card" key={label}>
              <Icon />
              <span>{label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default OperatorProfile;
